export default __webpack_public_path__ + "static/repeatingpattern-5749652ed993fb7e32dc230b59523ef5.png";